import { Modal, Input } from "antd";
import React, { useState, useEffect } from "react";
import { error, success } from "../../contants/snackbars";
import { addDistrict, editDistrict } from "../../stores/api_calls/locations";
import "./locations.scss";

export const DistrictAddForm = (props) => {
    const { onCancel, visible, getDistricts, data, refetchLists } = props;
    const [submitLoading, setSubmitLoading] = useState(false);
    const [form, setForm] = useState({
        districtName: "",
    });

    const handleFieldChange = (name, e) => {
        setForm({
            ...form,
            [name]: e.target.value,
        });
    };

    const onSubmit = () => {
        setSubmitLoading(true);
        const newData = {
            locationId: data._id,
            name: form.districtName,
        };

        const district = addDistrict(newData);

        district
            .then((res) => {
                if (res.data.success) {
                    getDistricts();
                    refetchLists(); // To update the count in parent table
                    success("District Added Successfully");
                    setSubmitLoading(false);
                    onClose();
                }
            })
            .catch((e) => {
                error(
                    `Opps! ${e.response?.data?.server_response || "Error"} . Fetched Failed. Please try again later`,
                );
                setSubmitLoading(false);
            });
    };

    const onClose = () => {
        onCancel();
        setForm({ ...form, districtName: "" });
    };

    return (
        <div>
            <Modal
                className="formModal"
                title={`Add District`}
                visible={visible}
                onOk={onSubmit}
                okButtonProps={{ disabled: form.districtName !== "" ? false : true }}
                onCancel={onClose}
                okText={`Create`}
                confirmLoading={submitLoading}
            >
                <div className="form-container">
                    <p className="form-label">
                        District Name <span>*</span> :{" "}
                    </p>
                    <Input
                        value={form.districtName}
                        onChange={(text) => handleFieldChange("districtName", text)}
                        placeholder="Please type District Name"
                    />
                </div>
            </Modal>
        </div>
    );
};

export const DistrictEditForm = (props) => {
    const { data, onCancel, visible, getDistricts } = props;
    const [submitLoading, setSubmitLoading] = useState(false);
    const [form, setForm] = useState({
        districtName: "",
    });

    useEffect(() => {
        if (data) {
            setForm({ ...form, districtName: data.name });
        }
    }, [data]);

    const handleFieldChange = (name, e) => {
        setForm({
            ...form,
            [name]: e.target.value,
        });
    };

    const onSubmit = () => {
        setSubmitLoading(true);
        const item = {
            locationId: data.location_id,
            districtId: data._id,
            districtName: form.districtName,
        };

        const district = editDistrict(item);

        district
            .then((res) => {
                if (res.data.success) {
                    getDistricts();
                    success("District Updated Successfully");
                    setSubmitLoading(false);
                    onClose();
                }
            })
            .catch((e) => {
                error(
                    `Opps! ${e.response?.data?.server_response || "Error"} . Fetched Failed. Please try again later`,
                );
                setSubmitLoading(false);
            });
    };

    const onClose = () => {
        onCancel();
    };

    return (
        <div>
            <Modal
                className="formModal"
                title={`Edit District`}
                visible={visible}
                onOk={onSubmit}
                okButtonProps={{ disabled: form.districtName !== "" ? false : true }}
                onCancel={onClose}
                okText={`Update`}
                confirmLoading={submitLoading}
            >
                <div className="form-container">
                    <p className="form-label">
                        District Name <span>*</span> :{" "}
                    </p>
                    <Input
                        value={form.districtName}
                        onChange={(text) => handleFieldChange("districtName", text)}
                        placeholder="Please type District Name"
                    />
                </div>
            </Modal>
        </div>
    );
};
